module.exports = __webpack_public_path__ + "static/media/Servicio Internet Satelital 1018 v11 Final.6f5b17d0.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/Servicio Internet Satelital 1018 v11 Final.pdf
// module id = 306
// module chunks = 0